// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3okON","savePackageButton":"ClientWallet_savePackageButton__1ZUlp"};